export const copyrightString = 'Copyright © 2022-2024 Tredder Inc.';
export const trademarkString = 'Tredder™';

export const tredderMainPhoneNumber = '801-610-9949';
export const tredderMainPhoneNumberHref = '8016109949';

export const tredderOverlandJournalPhoneNumber = '801-396-2029';
export const tredderOverlandJournalPhoneNumberHref = '8013962029';
